// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.root[data-v-18c623e1]{\r\n\tbackground: var(--main-gray-1);\r\n\tborder:1px solid var(--main-gray-2);\r\n\tborder-top:none;\r\n\theight: 400px;\r\n\tpadding: 0;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
